import { LANGUAGES } from '../constants/defaultValues';

export const updateSportEventCount = (sportsList, sportId, diff) => {
    return sportsList.map(sport => {
        if (sport.referenceId === sportId) {
            return {
                ...sport,
                eventCount: sport.eventCount + diff,
            };
        }

        return sport;
    });
};

export const deleteFavoriteEvent = (favoriteEvents, payload) => {
    if (favoriteEvents.find(event => event.id === payload.eventId)) {
        return favoriteEvents.filter(favoriteEvent => favoriteEvent.id !== payload.eventId);
    }
};

export const sortAlphabetically = (a, b) => {
    // equal items sort equally
    if (a === b) {
        return 0;
    }

    // nulls sort after anything else
    else if (!a) {
        return 1;
    } else if (!b) {
        return -1;
    }

    return a.toString().localeCompare(b, undefined, { numeric: true });
};

export const sortEventsByLeague = locale => (a, b) => {
    if (a.order === undefined || b.order === undefined) return 1;

    const nameOne = a.names[locale] || a.names[LANGUAGES.eng];
    const nameTwo = b.names[locale] || b.names[LANGUAGES.eng];

    return a.order - b.order || nameOne.localeCompare(nameTwo);
};

export const sortEventsByTime = (a, b) => {
    return (
        b.liveStatistics?.currentPeriodNumber - a.liveStatistics?.currentPeriodNumber ||
        b.liveStatistics?.eventTimeInMinutes - a.liveStatistics?.eventTimeInMinutes ||
        sortAlphabetically(b.liveStatistics?.eventTime, a.liveStatistics?.eventTime) ||
        a.startedAt - b.startedAt ||
        sortAlphabetically(a.id, b.id)
    );
};

export const sortEventsByMbn = (a, b) => {
    return a.mbn - b.mbn || a.startedAt - b.startedAt || sortAlphabetically(a.id, b.id);
};
